import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Container, Row, Col } from "reactstrap"
import TaskScreen from "./TaskScreen"

import { fetchData, fetchNodeData, FetchPostData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import { useParams } from "react-router-dom"
import Loader from "pages/Separate/Loader"
import MaintenanceTaskScreen from "./MaintenanceTaskScreen"
import axios from "axios"
import "../../../assets/css/Finance/Style/PayrollManagement/payroll_management.css"

const MaintenanceResourceIndex = () => {
  const [isLoading, setLoading] = useState(false)
  const [projectDetails, setProjectDetail] = useState({})
  const [maintenanceProjectDetails, setMaintenanceProjectDetail] = useState({})
  const token = secureLocalStorage.getItem("auth_token")
  const toggleLoading = loading => {
    setLoading(loading)
  }
  const params = useParams()
  const fetchProjects = async () => {
    const user_id = localStorage.getItem("auth_id")
    const roleId = secureLocalStorage.getItem("auth_role")
    const project_id = params?.id;
    try {
      const res = await fetchNodeData(toggleLoading, `getMaintenanceProject/${project_id}`)
      console.log(`res`, res)//true
      if (res?.status == true) {
        const projects = res?.data?.projects[0]
        console.log(`projects`, projects)
        setProjectDetail(projects)
        console.log(`projectDetails`, projectDetails)
      } 
    } catch (error) {
      console.error("Fetch error:", error)
    }
  }
  useEffect(() => {
    fetchProjects()
  }, [])

  const onUpdateDetails = (call, type) => {
    if (call) {
      fetchProjects(type)
    }
  }
  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumbs title={"Project Plan"} breadcrumbItem={"Development"} />
          <div id="credentialPage">
            <Row>
              <Col md="12" className="z-1 pe-0 ps-0">
                <MaintenanceTaskScreen
                  projectDetails={projectDetails}
                  toggleLoading={toggleLoading}
                  onUpdate={onUpdateDetails}
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default MaintenanceResourceIndex
